
import { removeFromSessionStorage } from '../utils/utilsStorage';

const logout = () => {
    if (window.location.pathname === '/login/success.php') {
        removeFromSessionStorage('privatePages');
        removeFromSessionStorage('pageId');
    }
}

export {
    logout
}